import React, { useEffect, useState } from 'react';
import { formatTime, listenAdminLogs } from '../services/firebase';
import { useLang } from '../lang/LangContext';

const LABELS = {
  settings_update: 'Updated settings',
  driver_approve: 'Approved captain',
  driver_unapprove: 'Unapproved captain',
  driver_block: 'Blocked captain',
  driver_unblock: 'Unblocked captain',
  user_block: 'Blocked passenger',
  user_unblock: 'Unblocked passenger',
  ride_cancel: 'Cancelled ride',
  ride_force_complete: 'Force-completed ride',
  map_ad_draft_saved: 'Saved Map Ad draft',
  map_ad_published: 'Published Map Ad',
  map_ad_pause: 'Paused Map Ad campaign',
  map_ad_resume: 'Resumed Map Ad campaign',
  map_ad_archive: 'Archived Map Ad campaign',
  map_ads_enabled: 'Enabled all Map Ads',
  map_ads_disabled: 'Disabled all Map Ads',
};

export default function Activity() {
  const { t } = useLang();
  const [logs, setLogs] = useState([]);

  useEffect(() => listenAdminLogs(setLogs), []);

  return (
    <div className="card">
      <div className="card-title">{t('Admin activity')}</div>
      {logs.length === 0 ? (
        <div className="empty">{t('No admin actions logged yet')}</div>
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>{t('WHEN')}</th>
                <th>{t('ACTION')}</th>
                <th>{t('ADMIN')}</th>
                <th>{t('DETAILS')}</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id}>
                  <td className="mono">{formatTime(l.createdAt)}</td>
                  <td>{LABELS[l.action] || l.action}</td>
                  <td className="muted">{l.adminEmail || l.adminUid}</td>
                  <td className="mono muted">{JSON.stringify(l.meta || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
